import React from "react";
import { Panel, PanelType } from "@fluentui/react";
import type ConstructionCalculationsNewPanelProps from "./ConstructionCalculationsNewPanelProps";
import styles from "./constructionCalculationsPanel.module.scss";
import ConstructionCalculationsNewPanelList from "../sidePanelList/ConstructionCalculationsNewPanelList";

const ConstructionCalculationsNewPanel: React.FunctionComponent<ConstructionCalculationsNewPanelProps> = ({
    open,
    calculations,
    isAllowToTakeAction,
    setCalculationPanelState
})  => {
    return (
        <Panel
            onDismiss={() => {
            setCalculationPanelState();
            }}
            type={PanelType.customNear}
            closeButtonAriaLabel="Close"
            isOpen={open}
            isLightDismiss
            isBlocking={true}
            customWidth="350px"
            className={styles.leftSideBar}>
            <div className={styles.calculationsContainer}>
            <ConstructionCalculationsNewPanelList
                calculations={calculations}
                isAllowToTakeAction={isAllowToTakeAction}
            />
            </div>
        </Panel>
    )
};

export default ConstructionCalculationsNewPanel;